import { render } from "./BrandsCreate.vue?vue&type=template&id=443cb4d3"
import script from "./BrandsCreate.vue?vue&type=script&lang=js"
export * from "./BrandsCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__